import React, { FC } from "react"
import { useSelector } from "react-redux"

import { getFeatures, getProduct, getProductFilters } from "@/onboarding/features/product/selectors"
import routes from "@/routes"
import ButtonLink from "@/components/ButtonLink"

const AcceptProposedChangesButton: FC = () => {
  const {
    season: { id: seasonId },
  } = useSelector(getProduct)
  const { contractPeriodId } = useSelector(getProductFilters)
  const features = useSelector(getFeatures)
  const flags = features.general.product
  const missingRoles: string[] = flags.acceptContractPeriodDetailsRejectionMissingRoles || []

  if (!flags.acceptContractPeriodDetailsRejection) {
    return null
  }

  // Always enabled, even when roles are missing: the modal explains which roles
  // the changes need, so the user can partially accept or fix their roles first.
  const title =
    missingRoles.length > 0
      ? `Accepting some of these changes requires the following role(s): ${missingRoles.join(
          ", "
        )}. The accept dialog explains your options.`
      : undefined

  return (
    <div title={title}>
      <ButtonLink
        label="Accept Proposed Changes"
        button={{ variant: "success" }}
        modal
        href={routes.new_onboarding_bidding_accept_contract_period_details_rejection_path({
          season_id: seasonId,
          contract_period_id: contractPeriodId,
        })}
      />
    </div>
  )
}

export default AcceptProposedChangesButton
